export const FORM_FIELD_NAMES = {
  corporateClientName: 'corporateClientName',
  numberOfDrivers: 'numberOfDrivers',
  country: 'country',
  firstName: 'firstName',
  lastName: 'lastName',
  mobilePhoneNumber: 'mobilePhoneNumber',
  email: 'email',
  password: 'password',
  termsAndPrivacyAgreement: 'termsAndPrivacyAgreement',
};

export const RegistrationFlow = {
  SELF_V1: 'SELF_V1',
  SELF_V2_UK: 'SELF_V2_UK',
  SELF_V2_NON_UK: 'SELF_V2_NON_UK',
};
